import { useMutation } from '@tanstack/react-query';

import { Envelope } from '../../../../types';
import { handleError } from '../../../../utils/admin';
import { useRequestConstructor } from '../../../hooks/useRequestConstructor';
import { createEnvelope } from '../../requests/createEnvelope';
import { CreateEnvelopePayload } from '../../types/CreateEnvelopePayload';

export const useCreateEnvelope = () => {
  const { constructPost } = useRequestConstructor();

  const { mutateAsync, ...rest } = useMutation<
    Envelope | undefined,
    Error,
    CreateEnvelopePayload
  >({
    mutationFn: (data) =>
      createEnvelope(constructPost, data).then((response) => response?.data),
    onError: () => handleError('Failed to create envelope.'),
  });

  return { createEnvelope: mutateAsync, ...rest };
};
